import axios from "axios";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { API } from "@/lib/api";
import { Stars, SERVICE_LABEL, VerifiedBadge } from "@/components/Reviews";
import { AdminLoadState } from "./AdminShell";
import { formatDate } from "./adminUtils";

export const ReviewsPanel = ({ resource }) => {
  const remove = async (review) => {
    if (!window.confirm(`Supprimer l'avis de ${review.name} ? Action définitive.`)) return;
    try {
      await axios.delete(`${API}/reviews/${review.id}`, { withCredentials: true });
      resource.setItems((list) => list.filter((item) => item.id !== review.id));
      toast.success("Avis supprimé");
    } catch { toast.error("Suppression impossible"); }
  };
  return <div data-testid="admin-reviews-panel">
    <h1 className="font-display uppercase text-4xl">Avis clients</h1>
    <p className="text-xs text-slate-500 mt-1" data-testid="admin-reviews-count">{resource.items.length} avis publié(s)</p>
    <AdminLoadState resource={resource} name="reviews" />
    {!resource.loading && !resource.error && resource.items.length === 0 && <p className="text-center text-slate-400 py-20" data-testid="admin-reviews-empty">Aucun avis pour le moment.</p>}
    <div className="mt-8 space-y-4">{resource.items.map((r) => <article key={r.id} className="glass border border-line rounded-2xl p-5 sm:p-6 break-words" data-testid={`admin-review-card-${r.id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <Stars value={r.rating} size={14} testId={`admin-review-stars-${r.id}`} />
        <span className="font-bold" data-testid={`admin-review-name-${r.id}`}>{r.name}</span>
        {r.verified && <VerifiedBadge size={11} testId={`admin-review-verified-${r.id}`} />}
        {r.author_email && <span className="font-mono-ui text-[11px] text-slate-400 break-all" data-testid={`admin-review-email-${r.id}`}>{r.author_email}</span>}
        <span className="text-[10px] uppercase text-slate-500" data-testid={`admin-review-service-${r.id}`}>{SERVICE_LABEL[r.service] || "Autre"}</span>
        <span className="text-[11px] text-slate-500 ml-auto" data-testid={`admin-review-date-${r.id}`}>{formatDate(r.created_at)}</span>
      </div>
      <p className="mt-3 text-slate-300 whitespace-pre-wrap leading-relaxed" data-testid={`admin-review-comment-${r.id}`}>{r.comment}</p>
      <button onClick={() => remove(r)} data-testid={`admin-delete-review-${r.id}`} className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-panel border border-line text-sm text-slate-300 hover:text-red-400 transition-colors"><Trash2 size={13} />Supprimer cet avis</button>
    </article>)}</div>
  </div>;
};